import axios from '../../../axios';
import IStripeClientSecretPayload from '../types/IStripeClientSecretPayload';

const url = 'api/razorpay';

export const getRazorPayInvoices = (subId: string) => axios.get(`${url}/invoices/${subId}`);

export const getRazorPayInvoice = (id: string) => axios.get(`${url}/invoice/${id}`);

export const getRazorPayEntPlanSubscription = () => axios.get(`${url}/fetch/ent-plan-sub`);

export const getRazorPayPlan = (planId: string) => axios.post(`${url}/get-plan/${planId}`);

export const getRazorPaySubId = (payload: IStripeClientSecretPayload) =>
  axios.post(`${url}/get-sub-id`, payload);

export const getRazorPayProratedCharge = (payload: IStripeClientSecretPayload) =>
  axios.post(`${url}/get-prorated-charge`, payload);

export const manageRazorPayCharge = (payload: IStripeClientSecretPayload) =>
  axios.post(`${url}/add-users`, payload);
